(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    (function() {
    function updateBanner() {
      const banner = document.getElementById('cart-note-banner');
      if (!banner) return;
      const textarea = document.querySelector('textarea[name="note"], #cart-note, .cart-note__input');
      const filled = textarea && textarea.value.trim() !== '';
      if (filled) { banner.classList.add('is-hidden'); } else { banner.classList.remove('is-hidden'); }
    }

    function initClickInversion() {
      const qtyContainer = document.querySelector('.cart-items__wrapper');
      if (!qtyContainer) return;

      qtyContainer.addEventListener('touchstart', function(e) {
        const btn = e.target.closest('.quantity-selector button');
        if (btn) { btn.classList.add('is-clicked'); }
      }, { passive: true });

      qtyContainer.addEventListener('touchend', function(e) {
        const btn = e.target.closest('.quantity-selector button');
        if (btn) { 
          setTimeout(() => { btn.classList.remove('is-clicked'); }, 80);
        }
      }, { passive: true });

      qtyContainer.addEventListener('mousedown', function(e) {
        const btn = e.target.closest('.quantity-selector button');
        if (btn) { btn.classList.add('is-clicked'); }
      });
      qtyContainer.addEventListener('mouseup', function(e) {
        const btn = e.target.closest('.quantity-selector button');
        if (btn) { btn.classList.remove('is-clicked'); }
      });
    }

    // Inicialização
    updateBanner();
    initClickInversion();

    document.addEventListener('input', function(e) {
      if (e.target.matches('textarea[name="note"], #cart-note, .cart-note__input')) { updateBanner(); }
    });

    document.addEventListener('cart:updated', function() {
      updateBanner();
      initClickInversion();
    });
    
    document.addEventListener('shopify:section:load', function() {
      updateBanner();
      initClickInversion();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    (function() {

    function isTermsAccepted() {
      const cb = document.getElementById('cart-terms-checkbox');
      return !cb || cb.checked;
    }

    function showTermsError() {
      const err = document.getElementById('cart-terms-error');
      const wrapper = document.getElementById('cart-terms-wrapper');
      const cb = document.getElementById('cart-terms-checkbox');
      if (!err || !wrapper) return;
      err.style.display = 'block';
      wrapper.classList.add('cart__terms-wrapper--error');
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => { if (cb) cb.focus(); }, 300);
    }

    function clearTermsError() {
      const err = document.getElementById('cart-terms-error');
      const wrapper = document.getElementById('cart-terms-wrapper');
      if (!err || !wrapper) return;
      err.style.display = 'none';
      wrapper.classList.remove('cart__terms-wrapper--error');
    }

    /* ── Patch do fetch global para bloquear /checkout ── */
    if (!window.__allpra_fetch_patched) {
      window.__allpra_fetch_patched = true;
      const _origFetch = window.fetch;
      window.fetch = function(input, init) {
        const url = (typeof input === 'string' ? input : (input && input.url)) || '';
        if (url.includes('/checkout') && !isTermsAccepted()) {
          showTermsError();
          return Promise.reject(new Error('Terms not accepted'));
        }
        return _origFetch.apply(this, arguments);
      };
    }

    /* ── Suprimir balão nativo de validação e mostrar sempre o aviso vermelho
       personalizado em vez dele. Flag PARTILHADA com o cart-drawer.liquid: se
       este script ainda não tiver carregado a tempo (ex: carrinho vazio no
       carregamento da página, produto adicionado e clique instantâneo em
       finalizar), a versão mínima já registada pelo cart-drawer.liquid garante
       o mesmo comportamento entretanto — por isso o registo aqui é ignorado
       se a flag já estiver definida. ── */
    if (!window.__allpra_invalid_delegated) {
      window.__allpra_invalid_delegated = true;
      document.addEventListener('invalid', function(e) {
        if (e.target && e.target.id === 'cart-terms-checkbox') {
          e.preventDefault();
          showTermsError();
        }
      }, true);
    }

    function init(forceReset) {
      const checkoutBtn = document.getElementById('checkout');
      if (!checkoutBtn) return;

      const cartForm = document.getElementById('cart-form');
      const cartActions = document.getElementById('cart-actions-wrapper');
      const termsCheckbox = document.getElementById('cart-terms-checkbox');

      /* ── Só desmarcar o checkbox E limpar o aviso quando a gaveta REALMENTE (re)abre.
         Nunca fazer isto por causa de mutações de conteúdo (badge de entrega,
         upsell de envio, etc.), senão atropela-se a escolha manual do cliente
         e o aviso de erro desaparece sozinho antes de o cliente conseguir lê-lo. ── */
      if (forceReset && termsCheckbox) {
        termsCheckbox.checked = false;
        clearTermsError();
      }

      /* ── Nota obrigatória ── */
      function getNoteValue() {
        const textarea = document.querySelector('textarea[name="note"], #cart-note, .cart-note__input');
        return textarea ? textarea.value.trim() : '';
      }

      function updateNoteState() {
        if (!cartActions) return;
        const filled = getNoteValue() !== '';
        cartActions.classList.toggle('cart-actions--note-filled', filled);
        cartActions.classList.toggle('cart-actions--note-required', !filled);
      }

      function highlightNote() {
        if (cartActions) {
          cartActions.classList.add('cart-note-highlight');
          cartActions.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => cartActions.classList.remove('cart-note-highlight'), 3000);
        }
        const details = document.querySelector('.cart-actions details');
        if (details && !details.open) details.open = true;
        const textarea = document.querySelector('textarea[name="note"], #cart-note, .cart-note__input');
        if (textarea) textarea.focus();
      }

      if (checkoutBtn.dataset.requiresNote) {
        document.addEventListener('input', function(e) {
          if (e.target.matches('textarea[name="note"], #cart-note, .cart-note__input')) {
            updateNoteState();
          }
        });
        updateNoteState();
      }

      /* ── Listener no checkbox ── */
      if (termsCheckbox) {
        termsCheckbox.addEventListener('change', function() {
          if (this.checked) {
            clearTermsError();
          }
        });
      }

      /* ── Interceptar clique no botão de checkout / botões acelerados (DELEGADO no document) ──
         Usa delegação em vez de agarrar o listener diretamente ao botão, porque no mobile
         a gaveta pode ser recriada (innerHTML substituído) ao adicionar um produto, trocando
         o botão por um nó novo sem listeners. Ouvir no document garante que funciona sempre,
         independentemente de quantas vezes o botão for recriado. ── */
      if (!window.__allpra_click_delegated) {
        window.__allpra_click_delegated = true;

        document.addEventListener('click', function(e) {
          const checkoutTarget = e.target.closest('#checkout');
          const acceleratedTarget = e.target.closest('.additional-checkout-buttons button, .additional-checkout-buttons [role="button"]');

          if (!checkoutTarget && !acceleratedTarget) return;

          if (!isTermsAccepted()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            showTermsError();
            return;
          }

          if (checkoutTarget && checkoutTarget.dataset.requiresNote && getNoteValue() === '') {
            e.preventDefault();
            e.stopImmediatePropagation();
            highlightNote();
            return;
          }
        }, true);

        document.addEventListener('submit', function(e) {
          if (!e.target.matches('#cart-form, form[action*="/cart"]')) return;

          const btn = document.getElementById('checkout');

          if (!isTermsAccepted()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            showTermsError();
            return;
          }
          if (btn && btn.dataset.requiresNote && getNoteValue() === '') {
            e.preventDefault();
            e.stopImmediatePropagation();
            highlightNote();
            return;
          }
        }, true);
      }

    }

    /* init() SEM argumento = só religa listeners/estado da nota, NUNCA mexe no checkbox */
    init();
    /* 'cart:updated' e 'shopify:section:load' representam re-renders completos da secção,
       por isso justificam reset do checkbox. Usa-se wrapper para não passar o objeto Event
       (que seria sempre "truthy") diretamente como forceReset. */
    document.addEventListener('cart:updated', function() { init(true); });
    document.addEventListener('shopify:section:load', function() { init(true); });

    /* ── Vigiar o atributo 'open' do <dialog> nativo da gaveta ──
       O <dialog> ganha o atributo 'open' sempre que é mostrado (showModal/show),
       seja por clique manual no ícone do carrinho, seja pelo auto-open disparado
       pelo CartAddEvent (ao adicionar um produto). Este é o ÚNICO ponto onde o
       checkbox é desmarcado (init(true)) — nunca por mutações de conteúdo. ── */
    function watchDialogOpen() {
      const dialog = document.querySelector('cart-drawer-component dialog[ref="dialog"], cart-drawer-component dialog');
      if (!dialog || dialog.__allpra_watched) return;
      dialog.__allpra_watched = true;

      const dialogObserver = new MutationObserver(function(mutations) {
        for (let i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'open' && dialog.hasAttribute('open')) {
            /* Espera o conteúdo da gaveta (cart-items-component) estabilizar antes de reiniciar */
            requestAnimationFrame(function() {
              requestAnimationFrame(function() {
                setTimeout(function() { init(true); }, 60);
              });
            });
            break;
          }
        }
      });
      dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    /* ── Fallback: apenas religar listeners quando o conteúdo muda (NUNCA reset do checkbox) ── */
    const cartObserverTarget = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, cart-items, #main-cart-items') || document.body;
    let cartObserverTimeout = null;
    const cartObserver = new MutationObserver(function() {
      clearTimeout(cartObserverTimeout);
      cartObserverTimeout = setTimeout(function() {
        init();
        watchDialogOpen();
      }, 50);
    });
    cartObserver.observe(cartObserverTarget, { childList: true, subtree: true });

    watchDialogOpen();

  })();
  } catch(e) { console.error(e); }
})();

})();
